"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Obj = _interopRequireDefault(require("./Obj"));
var _PubSub = _interopRequireDefault(require("./PubSub"));
var _batchPromises = _interopRequireDefault(require("batch-promises"));
var _SubObj = _interopRequireDefault(require("./SubObj"));
var _BasicObj = require("./BasicObj");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); } /*
 * MIT License
 *
 * Copyright (c) 2022 Massimo Candela <https://massimocandela.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var objectStatuses = ["new", "old", "mock", "deleted"];
var _merge = /*#__PURE__*/new WeakMap();
var _wipe = /*#__PURE__*/new WeakMap();
var _Store_brand = /*#__PURE__*/new WeakSet();
var _deleteByObject = /*#__PURE__*/new WeakMap();
var _insertObject = /*#__PURE__*/new WeakMap();
var Store = exports["default"] = /*#__PURE__*/function () {
  function Store() {
    var _this = this,
      _options$axios,
      _options$autoSave,
      _options$lazyLoad,
      _options$batchPersist;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Store);
    _classPrivateMethodInitSpec(this, _Store_brand);
    _defineProperty(this, "getModels", function () {
      return Object.keys(_this.models);
    });
    _defineProperty(this, "getModel", function (type) {
      var _this$models$type;
      return (_this$models$type = _this.models[type]) === null || _this$models$type === void 0 ? void 0 : _this$models$type.model;
    });
    _defineProperty(this, "findSync", function (type, filterFunction) {
      var all = Object.values(_this.models[type].storedObjects).filter(function (i) {
        return i.status !== "deleted";
      }).map(function (i) {
        return i.object;
      });
      return filterFunction ? all.filter(filterFunction) : all;
    });
    _defineProperty(this, "_validateTypeInput", function (type) {
      if (!_this.models[type]) {
        throw new Error("Not valid model type");
      }
    });
    _defineProperty(this, "_getDiffSync", function (type) {
      var objects = Object.values(_this.models[type].storedObjects).filter(function (i) {
        var _i$object;
        return !((_i$object = i.object) !== null && _i$object !== void 0 && _i$object.isMock());
      });
      var inserted = [];
      var updated = [];
      var deleted = [];
      var _iterator = _createForOfIteratorHelper(objects),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var object = _step.value;
          if (object.status === "new") {
            inserted.push(object);
          } else if (object.status === "deleted") {
            deleted.push(object);
          } else if (object.status === "old" && _this.hasChanged(type, object.object)) {
            updated.push(object);
          } // Nothing for mock objects
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        inserted: inserted,
        updated: updated,
        deleted: deleted
      };
    });
    _defineProperty(this, "refreshObjectByType", function (type) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this._getPromise(type).then(function () {
        var item = _this.models[type];
        var inserted = [];
        var deleted = [];
        var updated = [];
        item.promise = item.model.retrieveAll()["catch"](function () {
          var objects = Object.values(_this.models[type].storedObjects);
          var list = [];
          return (0, _batchPromises["default"])(4, objects, function (object) {
            return item.model.factory(object.object).then(function (items) {
              list = list.concat(items);
            })["catch"](function () {
              delete item.promise;
            }); // Nothing
          }).then(function () {
            return list;
          });
        }).then(function (objects) {
          var _iterator2 = _createForOfIteratorHelper(objects),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var object = _step2.value;
              var wrapper = new _Obj["default"](object, item.model);
              var _id = wrapper.getId();
              var currentObject = item === null || item === void 0 ? void 0 : item.storedObjects[_id];
              if (currentObject) {
                currentObject.deleted = false;
                if (currentObject.status === "deleted") {
                  currentObject.status = "old";
                }
                var newFingerprint = wrapper.getFingerprint();
                var oldFingerprint = currentObject.fingerprint;
                if (oldFingerprint !== newFingerprint || force) {
                  // Nothing to do otherwise
                  if (force) {
                    _classPrivateFieldGet(_wipe, _this).call(_this, currentObject.object);
                    _classPrivateFieldGet(_merge, _this).call(_this, currentObject.object, wrapper.toJSON());
                    currentObject.fingerprint = currentObject.object.getFingerprint();
                    updated.push(currentObject.object);
                  } else if (_this.hasChanged(type, currentObject.object)) {// Was the object edited locally?

                    // Nothing
                  } else {
                    // Update with the new object
                    _classPrivateFieldGet(_merge, _this).call(_this, currentObject.object, wrapper.toJSON());
                    currentObject.fingerprint = currentObject.object.getFingerprint();
                    updated.push(currentObject.object);
                  }
                }
              } else {
                var newObject = _classPrivateFieldGet(_insertObject, _this).call(_this, type, object, "old");
                item.storedObjects[newObject.getId()].deleted = false;
                inserted.push(newObject);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          for (var id in item === null || item === void 0 ? void 0 : item.storedObjects) {
            var obj = item.storedObjects[id];
            if (obj.deleted === undefined) {
              deleted.push(obj.object);
              delete item.storedObjects[id];
            } else {
              delete obj.deleted;
            }
          }
          return [inserted, updated, deleted];
        });
        return item.promise;
      });
    });
    _classPrivateFieldInitSpec(this, _merge, function (originalObject, newObject) {
      (0, _BasicObj.setValues)(newObject, originalObject.getModel(), _SubObj["default"], originalObject, originalObject);
    });
    _classPrivateFieldInitSpec(this, _wipe, function (originalObject) {
      originalObject === null || originalObject === void 0 || originalObject.shouldLoad(true);
      for (var key in originalObject) {
        if (key !== "id" && typeof originalObject[key] !== "function") {
          delete originalObject[key];
        }
      }
    });
    _classPrivateFieldInitSpec(this, _deleteByObject, function (object) {
      var id = object.getId();
      var filterFunction = function filterFunction(item) {
        return id === item.getId();
      };
      return _assertClassBrand(_Store_brand, _this, _deleteByFilter).call(_this, object.getModel().getType(), filterFunction);
    });
    _classPrivateFieldInitSpec(this, _insertObject, function (type, item, status) {
      var model = _this.models[type].model;
      var wrapper = new _Obj["default"](item, model);
      var id = wrapper.getId();
      if (_this.models[type].storedObjects[id]) {
        throw new Error("The IDs provided for the model ".concat(type, " are not unique"));
      }
      if (!objectStatuses.includes(status)) {
        throw new Error("The provided status is not valid");
      }
      if (status === "mock") {
        wrapper.isMock = function () {
          return true;
        };
        wrapper.insert = function () {
          _this.models[type].storedObjects[id].status = "new";
          wrapper.isMock = function () {
            return false;
          };
          _this.update([wrapper]);
          delete wrapper.insert;
        };
      }
      _this.models[type].storedObjects[id] = {
        id: id,
        fingerprint: wrapper.getFingerprint(),
        object: wrapper,
        status: status
      };
      return wrapper;
    });
    this.options = {
      axios: (_options$axios = options.axios) !== null && _options$axios !== void 0 ? _options$axios : null,
      autoSave: (_options$autoSave = options.autoSave) !== null && _options$autoSave !== void 0 ? _options$autoSave : true,
      saveDelay: options.saveDelay || 1000,
      lazyLoad: (_options$lazyLoad = options.lazyLoad) !== null && _options$lazyLoad !== void 0 ? _options$lazyLoad : false,
      batchPersistence: (_options$batchPersist = options.batchPersistence) !== null && _options$batchPersist !== void 0 ? _options$batchPersist : 1000,
      autoRefresh: options.autoRefresh === true ? 120000 : options.autoRefresh
    };
    this.models = {};
    this.pubSub = new _PubSub["default"]();
  }
  return _createClass(Store, [{
    key: "on",
    value: function on(channel, callback) {
      this.pubSub.subscribe(channel, callback);
    }
  }, {
    key: "validateModel",
    value: function validateModel(model) {
      var type = model.getType();
      if (typeof type !== "string" || type === "") {
        throw new Error("Not valid model object: type missing");
      }
    }
  }, {
    key: "addModel",
    value: function addModel(model) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2.validateModel(model);
        var type = model.getType();
        if (!_this2.models[type]) {
          var _model$options$lazyLo;
          _this2.models[type] = {
            model: model,
            storedObjects: {}
          };
          model.setStore(_this2);
          var lazyLoad = (_model$options$lazyLo = model.options.lazyLoad) !== null && _model$options$lazyLo !== void 0 ? _model$options$lazyLo : _this2.options.lazyLoad;
          if (lazyLoad) {
            resolve();
          } else {
            resolve(_assertClassBrand(_Store_brand, _this2, _loadObjects).call(_this2, type));
          }
        } else {
          var error = "The model already exists";
          _this2.pubSub.publish("error", error);
          reject(error);
        }
      });
    }
  }, {
    key: "update",
    value: function update(objects) {
      return Promise.resolve(objects); // Nothing to do at this level
    }
  }, {
    key: "delete",
    value: function _delete(typeOrObjects, filterFunction) {
      if (typeof typeOrObjects === "string" && typeof filterFunction === "function") {
        var type = typeOrObjects;
        return _assertClassBrand(_Store_brand, this, _deleteByFilter).call(this, type, filterFunction);
      } else if (Array.isArray(typeOrObjects) && typeOrObjects.length && !filterFunction) {
        var objects = typeOrObjects;
        return Promise.all(objects.map(_classPrivateFieldGet(_deleteByObject, this))).then(function (data) {
          return data.flat();
        });
      } else {
        var error = "Invalid delete request. You have to provide a list of objects or a type and a filter function";
        this.pubSub.publish("error", error);
        return Promise.reject(error);
      }
    }
  }, {
    key: "insert",
    value: function insert(type, objects) {
      var _this3 = this;
      return this._getPromise(type).then(function () {
        return objects.map(function (object) {
          return _classPrivateFieldGet(_insertObject, _this3).call(_this3, type, object, "new");
        });
      });
    }
  }, {
    key: "mock",
    value: function mock(type, objects) {
      var _this4 = this;
      return this._getPromise(type).then(function () {
        return objects.map(function (object) {
          return _classPrivateFieldGet(_insertObject, _this4).call(_this4, type, object, "mock");
        });
      });
    }
  }, {
    key: "get",
    value: function get(type, id) {
      var _this5 = this;
      return this._getPromise(type).then(function () {
        try {
          return _this5.models[type].storedObjects[id].object;
        } catch (error) {
          return Promise.reject("Object not found");
        }
      });
    }
  }, {
    key: "find",
    value: function find(type, filterFunction) {
      var _this6 = this;
      return this._getPromise(type).then(function () {
        return _this6.findSync(type, filterFunction);
      })["catch"](function (error) {
        _this6.pubSub.publish("error", error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "applyDiff",
    value: function applyDiff(_ref, type) {
      var _this7 = this;
      var _ref$inserted = _ref.inserted,
        inserted = _ref$inserted === void 0 ? [] : _ref$inserted,
        _ref$updated = _ref.updated,
        updated = _ref$updated === void 0 ? [] : _ref$updated,
        _ref$deleted = _ref.deleted,
        deleted = _ref$deleted === void 0 ? [] : _ref$deleted;
      return new Promise(function (resolve, reject) {
        try {
          var _iterator3 = _createForOfIteratorHelper(inserted.concat(updated)),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var object = _step3.value;
              type = type || object.object.getModel().getType();
              var newId = object.object.getId();
              var oldId = object.id;
              var item = _this7.models[type].storedObjects[object.id];
              if (newId !== oldId) {
                _this7.models[type].storedObjects[newId] = item;
                delete _this7.models[type].storedObjects[object.id];
              }
              item.fingerprint = object.object.getFingerprint();
              item.status = "old";
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          var _iterator4 = _createForOfIteratorHelper(deleted),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _object = _step4.value;
              delete _this7.models[type || _object.object.getModel().getType()].storedObjects[_object.id];
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(type, object) {
      var _this8 = this;
      this._validateTypeInput(type);
      var _hasChanged = function _hasChanged(type, object) {
        var obj = _this8.models[type].storedObjects[object.getId()];
        return !obj || obj.fingerprint !== obj.object.getFingerprint();
      };
      if (object) {
        return _hasChanged(type, object);
      } else {
        var _this$_getDiffSync = this._getDiffSync(type),
          inserted = _this$_getDiffSync.inserted,
          updated = _this$_getDiffSync.updated,
          deleted = _this$_getDiffSync.deleted;
        return [inserted, updated, deleted].some(function (i) {
          return i.length > 0;
        });
      }
    }
  }, {
    key: "preload",
    value: function preload(type) {
      return this._getPromise(type);
    }
  }, {
    key: "getDiff",
    value: function getDiff(type, ifLoaded) {
      var _this9 = this;
      this._validateTypeInput(type);
      return this._getPromise(type, ifLoaded).then(function () {
        return _this9._getDiffSync(type);
      });
    }
  }, {
    key: "factory",
    value: function factory(type, params) {
      var _this0 = this;
      var item = this.models[type];
      this.pubSub.publish("loading", {
        status: "start",
        model: type
      });
      item.promise = item.model.factory(params).then(function (items) {
        var _iterator5 = _createForOfIteratorHelper(items),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _item = _step5.value;
            _classPrivateFieldGet(_insertObject, _this0).call(_this0, type, _item, "old");
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        _this0.pubSub.publish("loading", {
          status: "end",
          model: type
        });
      })["catch"](function () {
        delete item.promise;
      });
      return item.promise;
    }
  }, {
    key: "_getPromise",
    value: function _getPromise(type) {
      var _this1 = this;
      var ifLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.models[type]) {
        return Promise.reject("The model doesn't exist");
      } else if (!this.models[type].promise && !this.options.lazyLoad) {
        return Promise.reject("The model is not loaded");
      } else if (!this.models[type].promise && this.options.lazyLoad && !ifLoaded) {
        return _assertClassBrand(_Store_brand, this, _loadObjects).call(this, type).then(function () {
          return _this1.models[type].promise;
        });
      } else if (!this.models[type].promise && this.options.lazyLoad && ifLoaded) {
        return Promise.resolve();
      } else {
        return this.models[type].promise;
      }
    }
  }, {
    key: "getCollection",
    value: function getCollection(type) {
      var _this10 = this;
      return this._getPromise(type).then(function () {
        return Object.values(_this10.models[type].storedObjects).filter(function (i) {
          return i.status !== "deleted";
        }).filter(function (i) {
          return i.status !== "mock";
        }).map(function (i) {
          return i.object;
        }).sort(function (a, b) {
          return a.getId().localeCompare(b.getId());
        }).map(function (i) {
          return i.toJSON();
        });
      });
    }
  }]);
}();
function _error(error) {
  error = error.message || error;
  this.pubSub.publish("error", error);
  return Promise.reject(error);
}
function _deleteByFilter(type, filterFunction) {
  var _this11 = this;
  return this._getPromise(type).then(function () {
    var deleted = Object.values(_this11.models[type].storedObjects).filter(function (i) {
      return filterFunction(i.object);
    });
    var _iterator6 = _createForOfIteratorHelper(deleted),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var object = _step6.value;
        object.status = "deleted";
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    return deleted.map(function (i) {
      return i.object;
    });
  });
}
function _loadObjects(type) {
  var _this12 = this;
  var item = this.models[type];
  this.pubSub.publish("loading", {
    status: "start",
    model: type
  });
  item.promise = item.model.retrieveAll().then(function (items) {
    var _iterator7 = _createForOfIteratorHelper(items),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _item2 = _step7.value;
        _classPrivateFieldGet(_insertObject, _this12).call(_this12, type, _item2, "old");
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    _this12.pubSub.publish("loading", {
      status: "end",
      model: type
    });
  });
  return item.promise;
}